import CancelButton from "@kamae-apps/shared/old/Component/Button/CancelButton"
import ValidateButton from "@kamae-apps/shared/old/Component/Button/ValidateButton"
import Select from "@kamae-apps/shared/old/Component/Input/Select"
import { Modal } from "@kamae-apps/shared/old/Component/NewModal/Modal"
import React, { FC } from "react"
import { CompanyData } from "../../../Companies"
import { useResetScoresModal } from "./useResetScoresModal"

type ResetScoresModalProps = {
  company: CompanyData
  display: boolean
  setDisplay: React.Dispatch<React.SetStateAction<boolean>>
}

export const ResetScoresModal: FC<ResetScoresModalProps> = ({ company, display, setDisplay }) => {
  const { loading, populations, types, population, type, setPopulation, setType, resetScores } = useResetScoresModal({
    company,
    setDisplay,
  })

  return (
    <Modal
      title={"Reset des scores"}
      display={display}
      setDisplay={setDisplay}
      width={"w-1/2"}
    >
      <p>Choisissez quelle population doit avoir un reset des scores et quels types de scores sont concernés.</p>
      <Select
        disabled={loading}
        defaultValue={population}
        className={"!z-50"}
        onChange={e => {
          setPopulation(e.target.value)
        }}
        options={
          populations?.map(v => ({
            value: v,
            name: v,
          })) ?? []
        }
        placeholder={"Population"}
      />
      <Select
        disabled={loading}
        defaultValue={type}
        className={"!z-50"}
        onChange={e => {
          setType(e.target.value)
        }}
        options={
          types?.map(v => ({
            value: v,
            name: v,
          })) ?? []
        }
        placeholder={"Type"}
      />
      <div className={"flex"}>
        <ValidateButton
          disabled={loading}
          validate={"Valider"}
          onClick={() => {
            resetScores(population, type)
          }}
          spinning={loading}
        />
        <CancelButton
          cancel={"Annuler"}
          onClick={() => {
            setDisplay(false)
          }}
        />
      </div>
    </Modal>
  )
}
